export default __webpack_public_path__ + "static/img-kyros-ventures-bb852b78cc056881e1035c249f9d7093.png";